import { useNavigate } from '@tanstack/react-router';
import { Button } from '../ui/button';
import { Badge } from '../ui/badge';
import { CircularProgressbar, buildStyles } from 'react-circular-progressbar';
import { useTheme } from '../../contexts/ThemeContext';
import 'react-circular-progressbar/dist/styles.css';

const PathwayCard = ({ pathway }) => {
    const navigate = useNavigate({ from: '/' });
    const { theme } = useTheme();

    return (
        <div className="border border-neutral-300 rounded-2xl p-4 flex flex-col gap-2 ">
            {/* Header */}
            <div className="flex justify-between items-center">
                <div>
                    <h3 className="capitalize">{pathway.title}</h3>
                    <div className="flex items-center gap-2 mt-1">
                        <Badge variant={pathway.progress === 100 ? 'completed' : 'active'}>
                            {pathway.progress === 100 ? 'completed' : pathway.progress === 0 ? 'not started' : 'active'}
                        </Badge>
                    </div>
                </div>
                <div className="text-center w-16">
                    <CircularProgressbar
                        value={pathway.progress ?? 0}
                        text={`${Math.round(pathway.progress ?? 0)}%`}
                        styles={buildStyles({
                            textColor: theme === 'dark' ? '#fff' : '#333', // Text color
                            pathColor: '#34c759', // Progress bar color
                            trailColor: theme === 'dark' ? '#262626' : '#E5E5E5', // Background color
                            textSize: '1.5rem', // Text size
                        })}
                    />
                </div>
            </div>

            {/* Description */}
            <p className="line-clamp-2">{pathway.description}</p>

            {/* Associated Courses */}
            <div className="inline-flex">
                <strong className="">Associated Courses: </strong>
                <p className="md:pl-0.5">
                    {(pathway.associatedCourses || [])
                        .map(course => course?.title)
                        .filter(Boolean)
                        .join(', ') || '—'}
                </p>
            </div>

            {/* Actions */}
            <div className="flex max-md:flex-col max-md:items-center gap-2">
                <Button
                    variant="destructive"
                    className="w-full py-1 flex justify-center items-center gap-2"
                    onClick={() =>
                        navigate({
                            to: '/pathway/$pathwayId',
                            params: { pathwayId: pathway.id },
                        })
                    }
                >
                    Track Progress
                </Button>
                {pathway.progress === 100 && (
                    <Button variant={'outline'} className="w-full py-1 flex justify-center items-center gap-2">
                        View Certificate
                    </Button>
                )}
            </div>
        </div>
    );
};
export default PathwayCard;
